export const Footer = () => {
  return (
    <footer>
      <p>
        Made by &nbsp;
        <a href="https://github.com/giancode1" target="_blank">
          giancode1
        </a>
        &nbsp; | &nbsp;
        <a href="https://twitter.com/GiancCool" target="_parent" rel="noopener">
          twitter
        </a>
      </p>
    </footer>
  );
};
